export { CampaignLandingElementWrapper } from './CampaignLandingElementWrapper';



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignLandingElementWrapper/index.js